import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureAssetLibraryHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureAssetLibraryHttp must be called before asset library API use')
  return http
}

export async function listAssetLibraryItems(query) {
  return client().get('/asset-library', { query, routeId: 'visualGame.assetLibrary.list' })
}

export async function createAssetLibraryItem(body) {
  return client().post('/asset-library', { body, routeId: 'visualGame.assetLibrary.create' })
}

export async function updateAssetLibraryItem(id, body) {
  return client().put(`/asset-library/${encodeURIComponent(id)}`, { body, routeId: 'visualGame.assetLibrary.update' })
}

export async function deleteAssetLibraryItem(id) {
  return client().delete(`/asset-library/${encodeURIComponent(id)}`, { routeId: 'visualGame.assetLibrary.delete' })
}

export async function listTalkingVideos(query) {
  return client().get('/talking-videos', { query, routeId: 'visualGame.talkingVideos.list' })
}

export async function listTalkingVideoSpecs(query) {
  return client().get('/talking-videos/specs', { query, routeId: 'visualGame.talkingVideos.specs' })
}

export async function reviewTalkingVideoPrompt(entityId, expressionState, body) {
  const path = `/talking-videos/${encodeURIComponent(entityId)}/${encodeURIComponent(expressionState)}/prompt/review`
  return client().post(path, { body, routeId: 'visualGame.talkingVideos.reviewPrompt' })
}

export async function getTalkingVideoFacets() {
  return client().get('/talking-videos/facets', { routeId: 'visualGame.talkingVideos.facets' })
}

export async function saveTalkingVideo(entityId, expressionState, body) {
  const path = `/talking-videos/${encodeURIComponent(entityId)}/${encodeURIComponent(expressionState)}`
  return client().put(path, { body, routeId: 'visualGame.talkingVideos.save' })
}

export async function withdrawTalkingVideo(entityId, expressionState, body) {
  const path = `/talking-videos/${encodeURIComponent(entityId)}/${encodeURIComponent(expressionState)}/withdraw`
  return client().post(path, { body, routeId: 'visualGame.talkingVideos.withdraw' })
}

export async function getTalkingVideoHistory(entityId, expressionState, packId) {
  const path = `/talking-videos/${encodeURIComponent(entityId)}/${encodeURIComponent(expressionState)}/history`
  return client().get(path, {
    query: { pack_id: packId },
    routeId: 'visualGame.talkingVideos.history',
  })
}

/** vg_media_assets 全表只读浏览——不是策展库那张表，是它底下真正存文件的那张。 */
export async function listMediaAssets(query) {
  return client().get('/media-assets', { query, routeId: 'visualGame.mediaAssets.list' })
}

/** 类型下拉 + 游戏下拉的候选值，来自实际数据而不是写死的枚举。 */
export async function getMediaAssetFacets() {
  return client().get('/media-assets/facets', { routeId: 'visualGame.mediaAssets.facets' })
}

/** 单条详情，展示这行在 vg_media_assets 里的全部字段。 */
export async function getMediaAsset(id) {
  return client().get(`/media-assets/${encodeURIComponent(id)}`, { routeId: 'visualGame.mediaAssets.detail' })
}
